import React from 'react';
import { Container, Card, Badge } from '../design-system';
import { Layout, Smartphone, Database, Cog } from 'lucide-react';

export function Services() {
  const services = [
    {
      icon: Layout,
      title: 'Desenvolvimento Web',
      description: 'Websites e aplicações web modernas, responsivas e otimizadas para conversão.',
      technologies: ['React', 'Next.js', 'TypeScript'],
      image: 'https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MXx8fHwxNzY2MDYxNDYwfDA&ixlib=rb-4.1.0&q=80&w=1080'
    },
    {
      icon: Smartphone,
      title: 'Aplicativos Mobile',
      description: 'Apps nativos e híbridos para iOS e Android com performance excepcional.',
      technologies: ['React Native', 'Flutter', 'Swift'],
      image: 'https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwxfHx8fDE3NjYxMjI2NDZ8MA&ixlib=rb-4.1.0&q=80&w=1080'
    },
    {
      icon: Database,
      title: 'Backend & APIs',
      description: 'Sistemas robustos e APIs escaláveis para suportar suas aplicações.',
      technologies: ['Node.js', 'Python', 'PostgreSQL'],
      image: 'https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjbG91ZCUyMHRlY2hub2xvZ3l8ZW58MXx8fHwxNzY2MTUxMzY3fDA&ixlib=rb-4.1.0&q=80&w=1080'
    },
    {
      icon: Cog,
      title: 'Consultoria Técnica',
      description: 'Orientação especializada para arquitetura, tecnologias e melhores práticas.',
      technologies: ['DevOps', 'AWS', 'Azure'],
      image: 'https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwxfHx8fDE3NjYxMjI2NDZ8MA&ixlib=rb-4.1.0&q=80&w=1080'
    }
  ];

  return (
    <section id="services" className="py-20 bg-slate-50">
      <Container maxWidth="xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Nossos Serviços
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Soluções digitais focadas em problemas reais, entregues de forma organizada, objetiva e segura.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card key={index} padding="none" hover>
                <div className="grid md:grid-cols-2 gap-0">
                  <div className="p-8">
                    <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-indigo-600" />
                    </div>
                    <h3 className="text-2xl font-semibold text-slate-900 mb-3">
                      {service.title}
                    </h3>
                    <p className="text-slate-600 mb-4">
                      {service.description}
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {service.technologies.map((tech) => (
                        <Badge key={tech} variant="secondary" size="sm">
                          {tech}
                        </Badge>
                      ))}
                    </div>
                  </div>
                  <div className="h-full min-h-[250px] md:min-h-0">
                    <picture>
                      <source
                        type="image/avif"
                        srcSet={`${service.image}&fm=avif&q=70&w=480 480w, ${service.image}&fm=avif&q=70&w=777 777w, ${service.image}&fm=avif&q=70&w=960 960w`}
                        sizes="(min-width:1024px) 50vw, 100vw"
                      />
                      <source
                        type="image/webp"
                        srcSet={`${service.image}&fm=webp&q=70&w=480 480w, ${service.image}&fm=webp&q=70&w=777 777w, ${service.image}&fm=webp&q=70&w=960 960w`}
                        sizes="(min-width:1024px) 50vw, 100vw"
                      />
                      <img
                        src={`${service.image}&fm=jpg&q=80&w=777`}
                        alt={service.title}
                        className="w-full h-full object-cover rounded-r-xl"
                        loading="lazy"
                        decoding="async"
                      />
                    </picture>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
